import { getConfigName } from "@helpers/funciones";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { signOut } from "aws-amplify/auth";
import CotizadorFinbe from "./producto/credito_simple/finbe/CotizadorFinbe";

const domainMap: Record<string, React.FC> = {
  finbe: CotizadorFinbe,

};

export const CotizadoresPreAprobacion = () => {
  const configName = getConfigName(window.location.href);
  const Component = domainMap[configName];

  useEffect(() => {
    const logout = async () => {
      localStorage.clear();
      await signOut();
    };

    logout();
  }, []);

  if (!Component) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
};
